<mat-form-field (click)="picker.open()">
	<mat-label>{{ title }}</mat-label>
	<input
		matInput
		[matDatepicker]="picker"
		[formControl]="formControl"
		readonly="true" />
	<mat-datepicker-toggle
		matSuffix
		[for]="picker"></mat-datepicker-toggle>
	<mat-datepicker
		#picker
		startView="multi-year"
		disabled="false"
		(monthSelected)="handleMonthChange($event, picker)"></mat-datepicker>
</mat-form-field>
